import { Gutter } from 'antd/lib/grid/row';
import { FormType } from 'enums/FieldTypeEnums';

export const CATEGORY5CONSTANTS = {
  LABELS: {
    TOTAL_WEIGHT_OF_ALL_PRODUCTS:
      'Total Weight of all products produced (tonnes)',
    TOTAL_WASTE: 'Total waste Produced (tonnes)',
    TOTAL_WASTE_WATER: 'Total Wastewater (m3)',
    WASTE_TYPE: 'Waste Type',
    WASTE_TREATMENT_METHOD: `Waste Treatment Method`,
  },
  FIELD_PRODUCTS_TOTAL_WEIGHT: 'productsTotalWeight',
  FIELD_TOTAL_WASTE: 'totalWasteProduced',
  FIELD_TOTAL_WASTE_WATER: 'totalWasteWater',
  FIELD_WASTETYPE_ID: 'wasteTypeId',
  FIELD_TREATMENT_METHOD: 'treatmentMethod',
  rowGutter: [50, 40] as Gutter,
  formType: FormType.REACT_HOOK_FORMS,
};
